import { pathOr } from 'ramda';

import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const FETCH_CART_REQUEST = 'app/CartPage/FETCH_CART_REQUEST';
export const FETCH_CART_SUCCESS = 'app/CartPage/FETCH_CART_SUCCESS';
export const FETCH_CART_ERROR = 'app/CartPage/FETCH_CART_ERROR';

// ================ Reducer ================ //

const initialState = {
  pagination: null,
  fetchCartInProgress: false,
  fetchCartError: null,
  fetchCartSuccess: false,
};

const cartReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CART_REQUEST:
      return {
        ...state,
        fetchCartInProgress: true,
        fetchCartError: null,
        fetchCartSuccess: false,
      };
    case FETCH_CART_SUCCESS:
      return {
        ...state,
        fetchCartInProgress: false,
        fetchCartSuccess: true,
      };
    case FETCH_CART_ERROR:
      console.error(payload);
      return {
        ...state,
        fetchCartInProgress: false,
        fetchCartError: payload,
        fetchCartSuccess: false,
      };

    default:
      return state;
  }
};

export default cartReducer;


// ================ Action creators ================ //

export const fetchCartRequest = queryParams => ({
  type: FETCH_CART_REQUEST,
  payload: { queryParams },
});

export const fetchCartSuccess = () => ({
  type: FETCH_CART_SUCCESS,
});

export const fetchCartError = e => ({
  type: FETCH_CART_ERROR,
  error: true,
  payload: e,
});

export const fetchCartListings = (ids) => async (dispatch, getState, sdk) => {
  dispatch(fetchCartRequest());

  return sdk.listings.query({
    ids,
    include: ['images'],
    'fields.image': ['variants.landscape-crop', 'variants.landscape-crop2x'],
    'limit.images': 1,
  })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchCartSuccess())
    })
    .catch(e => {
      dispatch(fetchCartError(storableError(e)));
      throw e;
    })
};

export const loadData = () => (dispatch, getState, sdk) => {
  return Promise.all([dispatch(fetchCurrentUser())])
    .then(response => {
      const currentUser = getState().user.currentUser;
      const myCart = pathOr([], ['attributes', 'profile', 'publicData', 'addToCart'], currentUser);
      if (currentUser && myCart.length > 0) {
        dispatch(fetchCartListings(myCart));
      }
      return response;
    })
    .catch(e => {
      throw e;
    });
};
